import React from 'react';
import DashletListForm from '../../appDahsboard/forms/dashletListForm';
import DashletStatisticForm from '../../appDahsboard/forms/dashletStatisticForm';

const oriState = {
  title: undefined,
  isListFormSelected: true,
  isStatsFormSelected: false,
  isFromExisting: false,
};

export default class ModalDashlet extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.reset = this.reset.bind(this);
    this.close = this.close.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleTab = this.toggleTab.bind(this);
  }

  reset() {
    this.state = oriState;
    this.dashletStatisticForm.reset();
    this.dashletListForm.reset();
  }

  close() {
    this.reset();
    this.setState({
      isFromExisting: false,
    });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  toggleTab(tab) {
    if (tab === 'list') {
      this.setState({
        isListFormSelected: true,
        isStatsFormSelected: false,
      });
    } else {
      this.setState({
        isListFormSelected: false,
        isStatsFormSelected: true,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    /*
            When the component receive props from the component DashletStatistic, we need to set the fromExisting
            attribute to true
         */
    if (prevProps.fromExisting === undefined && prevProps.fromExisting !== this.props.fromExisting) {
      let existingDashlet = this.props.fromExisting();
      let formStatToDisplay = existingDashlet.type !== 'dashlet-list' ? true : false;
      this.setState({
        isFromExisting: true,
        isListFormSelected: !formStatToDisplay,
        isStatsFormSelected: formStatToDisplay,
      });
    }
  }

  handleSubmit() {
    if (this.state.isStatsFormSelected) {
      this.dashletStatisticForm.handleSubmit();
    } else {
      this.dashletListForm.handleSubmit();
    }
    this.close();
  }

  render() {
    if (this.props.isOpen === false) return null;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-xl'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>Créer Dashlet</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>

            <form>
              <div className='modal-body modal-dashlet-body'>
                <ul className='tab-menu'>
                  <li onClick={(tab) => this.toggleTab('list')} className='active'>
                    {this.state.isListFormSelected ? (
                      <strong>
                        <span className='icon icon-list'> Liste </span>
                      </strong>
                    ) : (
                      <span className='icon icon-list'> Liste </span>
                    )}
                  </li>
                  <li onClick={(tab) => this.toggleTab('statistics')}>
                    {this.state.isStatsFormSelected ? (
                      <strong>
                        <span className='icon icon-pie-chart'>Statistiques</span>
                      </strong>
                    ) : (
                      <span className='icon icon-pie-chart'>Statistiques</span>
                    )}
                  </li>
                </ul>

                <DashletListForm
                  onRef={(ref) => (this.dashletListForm = ref)}
                  isListFormSelected={this.state.isListFormSelected}
                  onPostResult={this.props.onPostResult}
                  openToast={this.props.openToast}
                  fillFromExisting={this.props.fromExisting}
                />
                <DashletStatisticForm
                  onRef={(ref) => (this.dashletStatisticForm = ref)}
                  isStatsFormSelected={this.state.isStatsFormSelected}
                  openToast={this.props.openToast}
                  onPostResult={this.props.onPostResult}
                  fillFromExisting={this.props.fromExisting}
                />
              </div>
              <div className='modal-actions'>
                <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                  Annuler
                </button>
                <button
                  onClick={this.handleSubmit}
                  type='button'
                  className='btn-link modal-action'
                  data-dismiss='modal'
                >
                  <strong>{this.state.isFromExisting ? 'Modifier' : 'Créer'}</strong>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
